module.exports = __webpack_public_path__ + "media/promo/hochland/images/bg_1-cfb2658c1950ddcd330e1017e9b03e3f.png";